import React, { PropTypes } from 'react';
import { FontIcon } from 'material-ui';
import DateUtils from '../../../utils/date-utils';
import MouseOverEditDiv from '../../tc-ui/mouse-over-edit-div';
import EditButton from './edit-button';
import moment from 'moment';
import { isEmpty, complement } from 'ramda';
const notEmpty = complement(isEmpty);

const SeasonErrors = ({ seasonDateRanges, startDate, endDate, openAddEditContractDialog, existingSeasons, editable }) => {
  if (isEmpty(seasonDateRanges)) return <div/>;
  const notInContractingPeriodString = DateUtils.notInContractingPeriod(seasonDateRanges, startDate, endDate);
  if (notInContractingPeriodString) {
    // this error is handled in helper-link.jsx
    return <div/>;
    // return (
    //   <div style={{ marginTop: '12px', color: '#f44336' }}>
    //     <FontIcon className="tc-icon-warning" style={{ fontSize: '16px', color: '#f44336' }} /> {notInContractingPeriodString}
    //   </div>
    // );
  }
  const missingRanges = DateUtils.getMissingRanges(seasonDateRanges, { startDate, endDate });
  if (notEmpty(missingRanges)) {
    return (
      <div style={{ marginTop: '12px', color: '#f44336' }}>
        <FontIcon className="tc-icon-warning2" style={{ fontSize: '16px', color: '#f44336' }} /> <b>Missing Dates:</b>
        <MouseOverEditDiv
          actionButtons={
            <EditButton
              editLabel="Assign Dates to A Season"
              onEdit={() => openAddEditContractDialog({
                type: 'editSeason',
                data: {
                  seasonIndex: -1,
                  missingDatesIndexSelected: missingRanges.map((_, i) => i),
                  assignToSeasonIndex: -1,
                  title: 'Edit Season',
                },
              })}
            />}
          editable={editable}
        >
          {
            missingRanges.map((range, index) => (
              <div key={index} style={{ marginLeft: '20px', color: 'rgba(0, 0, 0, 0.54)' }}>
                {
                  moment(range.from).isSame(range.to, 'day') ? DateUtils.dateToString(range.from) :
                    `${DateUtils.dateToString(range.from)} - ${DateUtils.dateToString(range.to)}`
                }
              </div>
            ))
          }
        </MouseOverEditDiv>
      </div>
    );
  }
  return <div/>;
};

SeasonErrors.propTypes = {
  seasonDateRanges: PropTypes.array.isRequired,
  startDate: PropTypes.any,
  endDate: PropTypes.any,
};

export default SeasonErrors;



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/season-errors.jsx